import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { banners } from "@/mocks/meta";
import { getWorkById, workTypeLabel } from "@/lib/workUtils";

export default function HeroCarousel() {
  const [active, setActive] = useState(0);
  const activeWork = getWorkById(banners[active].workId);

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((prev) => (prev + 1) % banners.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative w-full">
      <div className="relative h-[440px] w-full overflow-hidden md:h-[600px]">
        {banners.map((banner, index) => {
          return (
            <div
              key={banner.workId}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                index === active ? "opacity-100" : "opacity-0"
              }`}
              aria-hidden={index !== active}
            >
              <img
                src={banner.backdrop}
                alt={`${banner.title}剧照`}
                title={`${banner.title} 剧情介绍`}
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/60 to-primary-950/20" />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-transparent to-primary-950/30" />
            </div>
          );
        })}

        <div className="relative z-10 mx-auto flex h-full w-full flex-col justify-end px-4 pb-14 md:px-8 md:pb-20">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-md bg-accent-500 px-3 py-1.5 text-xs font-bold text-primary-950">
              <i className="ri-fire-line text-sm" />
              {banners[active].kicker}
            </span>
            <h1 className="mt-4 font-heading text-3xl font-extrabold tracking-tight text-background-50 md:text-5xl">
              {banners[active].title}
            </h1>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-200 md:text-base">
              {banners[active].tagline}
            </p>
            <div className="mt-7 flex flex-wrap items-center gap-3">
              <Link
                to={`/detail/${banners[active].workId}`}
                className="flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-primary-950 transition-colors hover:bg-accent-400"
              >
                <i className="ri-play-circle-line text-lg" />
                查看详情
              </Link>
              {activeWork && (
                <Link
                  to={`/category/${activeWork.type}`}
                  className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-200/60 bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
                >
                  浏览{workTypeLabel(activeWork.type)}
                </Link>
              )}
            </div>
          </div>

          <div className="mt-10 flex items-center gap-2">
            {banners.map((banner, index) => (
              <button
                key={banner.workId}
                type="button"
                aria-label={`切换到${banner.title}`}
                onClick={() => setActive(index)}
                className={`h-1.5 rounded-full transition-all duration-300 ${
                  index === active ? "w-10 bg-accent-500" : "w-5 bg-background-200/60"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}